var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83094 9.29929C4.18021 6.15585 6.83721 3.77771 10 3.77771V3.77771C13.1628 3.77771 15.8198 6.15584 16.1691 9.29929L16.4488 11.8173C16.4737 12.0412 16.4862 12.1532 16.5016 12.2636C16.6397 13.2543 16.9624 14.2104 17.4529 15.0821C17.5076 15.1793 17.5656 15.2759 17.6815 15.4691L18.3238 16.5395C18.9994 17.6656 19.3372 18.2286 19.1728 18.6773C19.1351 18.7802 19.0807 18.8762 19.0119 18.9614C18.7117 19.3333 18.0551 19.3333 16.742 19.3333H3.25804C1.94487 19.3333 1.28828 19.3333 0.988089 18.9614C0.919271 18.8762 0.864929 18.7802 0.827236 18.6773C0.662815 18.2286 1.00063 17.6656 1.67625 16.5395L2.31851 15.4691C2.43442 15.2759 2.49238 15.1793 2.54706 15.0821C3.03761 14.2104 3.36031 13.2543 3.49844 12.2636C3.51384 12.1532 3.52628 12.0412 3.55116 11.8173L3.83094 9.29929Z",
    stroke: "#475496",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78023 20.0718C6.97014 21.135 7.38863 22.0744 7.97077 22.7445C8.55292 23.4145 9.2662 23.7777 9.99998 23.7777C10.7338 23.7777 11.447 23.4145 12.0292 22.7445C12.6113 22.0744 13.0298 21.135 13.2197 20.0718",
    stroke: "#475496",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1V3.22222",
    stroke: "#475496",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.32b4d36b4143d350390fc22428eda295.svg";
export { ForwardRef as ReactComponent };